export default "__VITE_ASSET__3QvNnYXh__"